<template>
  <div>
    <data-table-card
      :items="items"
      v-on:updateData="getCustomers"
      :sortOptions="sortOptions"
      :filterOptions="filterOptions"
      :sort="sort"
      :isLoad="isLoad"
      :page="page"
      :rowsPerPage="rowsPerPage"
      :fromRow="fromRow"
      :toRow="toRow"
      :totalRows="totalRows"
      :lastPage="lastPage"
    >
      <template v-slot:header-buttons v-if="userHasPerms(['Manage customers'])">
        <b-button
          class="ml-2"
          :to="{ name: 'customers-create' }"
          variant="primary"
        >
          <i class="lni lni-circle-plus m-0"></i>
        </b-button>
           <b-button
          class="ml-2"
          :to="{ name: 'customers-upload' }"
          variant="primary"
        >
          Upload
        </b-button>
      </template>

      <template v-slot:cards="slotProps">
        <router-link
          :to="{
            name: 'customers-show',
            params: { id: slotProps.item.id },
          }"
          class="text-body pointer text-decoration-none"
        >
          <div class="row no-gutters">

            <div class="col-12 p-3">
              <h5 class="font-weight-bold mb-0">{{ slotProps.item.name }}</h5>
               <strong>{{ slotProps.item.rapid_code }} </strong> <small class="text-muted">TA {{ slotProps.item.trading_as }} | {{ slotProps.item.area }}</small><br><br>


                <span v-if="slotProps.item.rep && slotProps.item.rep.user"> <i class="lni lni-user"></i> {{ slotProps.item.rep.user.name }}  </span> <span class="badge badge-warning float-right" v-if="slotProps.item.branch">{{ slotProps.item.branch.code }}</span>
            </div>
          </div>
        </router-link>

      </template>
    </data-table-card>

    <div class="row my-5">
      <div class="col">
        <div class="card">
          <div class="card-body">
            <table class="table">
              <thead>
                <tr>
                  <th>Branch</th>
                   <th>When</th>
                  <th class="text-right">Updated</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="branch in branches" :key="branch.id">
                  <td>{{ branch.name }}</td>
                  <td>{{
                        moment(new Date(branch.customers_uploaded_on)).fromNow()
                      }}
                  </td>
                  <td class="text-right">{{
              moment(new Date(branch.customers_uploaded_on)).format(
                "DD MMM YYYY, HH:mm:ss"
              )
            }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      :hide-footer="true"
      :title="$route.meta.title"
      size="lg"
      v-model="sidebarToggle"
      :no-close-on-route-change="true"
      @hidden="$router.push({ name: 'customers' })"
      :lazy="true"
    >
      <router-view
        @customerCreated="customerCreated()"
        @customerUpdated="customerUpdated()"
      ></router-view>
    </b-modal>
  </div>
</template>

<script>
import customerRepo from "@/api/repos/customerRepo";
import dataTableCard from "@/components/common/DataTableCard";

export default {
  components: {
    dataTableCard: dataTableCard,
  },

  data() {
    return {
      sidebarToggle: false,
      isLoad: false,
      sort: { column: "name", label: "Name Asc", order: "asc" },
      sortOptions: [
        { column: "name", label: "Name Asc", order: "asc" },
        { column: "name", label: "Name Desc", order: "desc" },
        { column: "created_at", label: "Date Created Asc", order: "asc" },
        { column: "created_at", label: "Date Created Desc", order: "desc" },
        { column: "rapid_code", label: "Rapid Code Asc", order: "asc" },
        { column: "rapid_code", label: "Rapid Code Desc", order: "desc" },
        { column: "trading_as", label: "Trading As Asc", order: "asc" },
        { column: "trading_as", label: "Trading As Desc", order: "desc" },
      ],
      filterOptions: [],
      filterStr: null,
      page: 1,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 12,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      items: [],
      branches: []
    };
  },
  mounted() {
    this.getCustomers({
      sort: this.sort,
      filters: null,
      page: this.page,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 12,
      search: "",
    });
  },
  methods: {
    async getFilterData() {
      let { data } = await customerRepo.createGetData();

      this.filterOptions.push({
        column: "group-heading",
        label: "branches",
      });

      data.branches.forEach((b) => {
        this.filterOptions.push({
          column: "branch_id",
          value: b.id,
          label: b.name,
        });
      });


    },

    async getCustomers(e) {

        if(e.filters != null){
            this.filterStr = e.filters
        }else{
            this.filterStr = null
        }

      this.isLoad = true;
      try {
        let { data } = await customerRepo.customers(
          e.page,
          e.rowsPerPage,
          e.sort.column,
          e.sort.order,
          e.search,
          this.filterStr
        );

        this.items = data.customers.data;
        this.totalRows = data.customers.total;
        this.page = data.customers.current_page;
        this.fromRow = data.customers.from;
        this.toRow = data.customers.to;
        this.lastPage = data.customers.last_page;
        this.branches = data.branches;
        this.filterOptions = [];



        this.getFilterData();
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },

    customerCreated() {
      this.$bvToast.toast("Customer Created", {
        title: "Success",
        autoHideDelay: 3000,
        variant: "success",
      });
      this.sort = {
        column: "created_at",
        label: "Date Created Desc",
        order: "desc",
      };
      this.page = 1;
      this.sidebarToggle = false;
      this.getCustomers({
        sort: this.sort,
        filters: null,
        page: this.page,
        rowsPerPage: localStorage.getItem("rowsPerPage")
          ? localStorage.getItem("rowsPerPage")
          : 12,
        search: "",
      });
    },

    customerUpdated() {
      this.$bvToast.toast("Customer Updated", {
        title: "Success",
        autoHideDelay: 3000,
        variant: "success",
      });
      this.sidebarToggle = false;
      this.getCustomers({
        sort: this.sort,
        filters: this.filterStr,
        page: this.page,
        rowsPerPage: localStorage.getItem("rowsPerPage")
          ? localStorage.getItem("rowsPerPage")
          : 12,
        search: "",
      });
    },
  },

  watch: {
    $route: {
      immediate: true,
      handler: function (newVal) {
        this.sidebarToggle = newVal.meta && newVal.meta.sidebarToggle;
      },
    },
  },
};
</script>
